module.exports = __webpack_public_path__ + "img/228-986ee6.png";